import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Home from "@/pages/Home";
import Titulos from "@/pages/Titulos";
import TrophyDetail from "@/pages/TrophyDetail";
import Tienda from "@/pages/Tienda";
import Contacto from "@/pages/Contacto";
import QuienesSomos from "@/pages/QuienesSomos";
import Info from "@/pages/Info";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Toaster } from "sonner";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = hash;
      let attempts = 0;
      let lastTop = null;
      let stableCount = 0;
      const maxAttempts = 40;

      const tick = () => {
        attempts += 1;
        const el = document.querySelector(target);
        if (!el) {
          if (attempts < maxAttempts) requestAnimationFrame(tick);
          return;
        }
        const rect = el.getBoundingClientRect();
        const desiredScrollY = window.scrollY + rect.top - 80;
        window.scrollTo({ top: desiredScrollY, behavior: "auto" });

        if (lastTop !== null && Math.abs(rect.top - lastTop) < 1) {
          stableCount += 1;
        } else {
          stableCount = 0;
        }
        lastTop = rect.top;

        if (stableCount < 4 && attempts < maxAttempts) {
          requestAnimationFrame(tick);
        }
      };

      requestAnimationFrame(tick);
      return;
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

function Chrome({ children }) {
  const { pathname } = useLocation();
  // The /info (beacons) page is a standalone layout — no chrome around it.
  const isBare = pathname.startsWith("/info");
  return (
    <>
      {!isBare && <Navigation />}
      {children}
      {!isBare && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <div className="App grain-bg min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <Chrome>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/info" element={<Info />} />
            <Route path="/quienes-somos" element={<QuienesSomos />} />
            <Route path="/titulos" element={<Titulos />} />
            <Route path="/titulos/:slug" element={<TrophyDetail />} />
            <Route path="/tienda" element={<Tienda />} />
            <Route path="/contacto" element={<Contacto />} />
          </Routes>
        </Chrome>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#0A1121",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#F8F9FA",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}
